import './create-nonce.js';
import 'jquery';
import '@uirouter/angularjs';
import 'angular-animate/angular-animate.min.js';
import 'angular-cookies/angular-cookies.min.js';
import 'angular-dynamic-locale';
import 'angular-ui-bootstrap';
import 'angular-ui-tree/dist/angular-ui-tree.js';
import 'angular-applicationinsights';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import 'bootstrap-material-design/dist/js/material.min.js';
import 'bootstrap-material-design/dist/js/ripples.min.js';
import '../assets/js/inputSelectAll.js';
// Stylesheets
// Bootstrap
import 'bootstrap/dist/css/bootstrap.min.css';
import '../Content/custom-bootstrap.css';
//Material icons + Roboto font
import 'bootstrap-material-design-icons/css/material-icons.min.css';
import 'roboto-font/css/fonts.css';
//Bootstrap Material Design
import 'bootstrap-material-design/dist/css/bootstrap-material-design.min.css';
import 'bootstrap-material-design/dist/css/ripples.min.css';
//nouislider
import 'nouislider/distribute/nouislider.min.css';
//Spinner
import '../assets/css/spinners/loader.css';
//angular-ui-tree
import 'angular-ui-tree/dist/angular-ui-tree.min.css';
//ui controls
import '../assets/css/collapsible.css';
//csp styles
import 'angular/angular-csp.css';
import 'angular-ui-bootstrap/dist/ui-bootstrap-csp.css';
//Our own styles
import '../assets/css/site.css';

import * as angular from 'angular';
import noUiSliderModule from 'angularjs-nouislider';
import singleSpaAngularJS from 'single-spa-angularjs';

import { ApplicationInsights } from '@microsoft/applicationinsights-web';

import { omrpCollapsible } from '../assets/js/collapsible';
import { omrpColorpicker } from '../assets/js/colorpicker';
import { omrpDatepicker } from '../assets/js/datepicker';
import { omrpDropdownFilter } from '../assets/js/dropdownFilter';
import { omrpDropdownTree } from '../assets/js/dropdownTree';
import { omrpDynamicInput } from '../assets/js/dynamicInput';
import { omrpSlider } from '../assets/js/slider';
import { omrpTaglist } from '../assets/js/taglist';
import {
    auth0config, authinterceptorconfig, clickconfig, localeconfig, routeconfig, stateconfig
} from './app.routes';
import { ActivityController } from './components/activityManagement/activityController';
import { ActivityPasteController } from './components/activityPaste/activityPasteController';
import {
    CustomCounterPeriodController
} from './components/customCounterPeriod/customCounterPeriodController';
import {
    ExchangeUpdateConfigurationController
} from './components/exchangeConfiguration/exchangeUpdateConfigurationController';
import { LangSwitchCtrl } from './components/i18n/langswitchController';
import { translationService } from './components/i18n/translationService';
import { indexPage } from './components/indexPage/indexPageController';
import { authenticationService } from './components/login/authenticationService';
import { authInterceptorService } from './components/login/authInterceptorService';
import { AuthorizeController } from './components/login/authorizeController';
import { LoginController } from './components/login/loginController';
import { LoginLogoutLinkController } from './components/login/loginLogoutLinkController';
import { notificationService } from './components/login/notificationService';
import { SaveSSOTokenController, SSOLoginData } from './components/login/saveSSOTokenController';
import { tokenExpiredInterceptorService } from './components/login/tokenExpiredInterceptorService';
import { MergeConflictsController } from './components/mergeConflicts/mergeConflictsController';
import { modalWithCheckbox } from './components/modalWithCheckbox/modalWithCheckbox';
import {
    MonitoringPageComponentCtrl
} from './components/monitoring/monitoringPageComponentController';
import { MonitoringPageCtrl } from './components/monitoring/monitoringPageController';
import { MonitoringPageCtrlBase } from './components/monitoring/monitoringPageControllerBase';
import {
    MonitoringPageInstanceCtrl
} from './components/monitoring/monitoringPageInstanceController';
import { MultiSelectController } from './components/multiSelect/multiSelectController';
import {
    NarrowCastingConfigCtrl
} from './components/narrowCastingConfiguration/narrowCastingConfigurationController';
import { permissionService } from './components/permissions/permissionService';
import { PlanboardCtrl } from './components/planboard/PlanboardController';
import { PlanningStatusController } from './components/planningStatus/planningStatusController';
// Uncomment the line below to enable the performance test page on a release build(DANGEROUS).
// import { PerfTestCtrl } from './components/performanceTest/performanceTestController';
import {
    activityTypesCtrl
} from './components/programManagement/activityTypes/activityTypesController';
import { ReplaceResourceController } from './components/replaceResource/replaceResourceController';
import {
    ResourceCombinationsController
} from './components/resourceCombinations/resourceCombinationsController';
import { ResourcesController } from './components/resourceManagement/resourcesController';
import {
    ResourceParttimeScheduleController
} from './components/resourceParttimeSchedule/resourceParttimeScheduleController';
import {
    ResourcePeriodBoundPropertiesController
} from './components/resourcePeriodBoundProperties/resourcePeriodBoundPropertiesController';
import {
    ScenarioManagementController
} from './components/scenarioManagement/scenarioManagementController';
import {
    SolverManagementController
} from './components/solverManagement/solverManagementController';
import { UpgradeDaymarkController } from './components/upgradeDaymark/upgradeDaymarkController';
import { UserPreferencesController } from './components/userPreferences/userPreferencesController';
import {
    modalConfirmationWindowCtrl, modalConfirmationWindowService
} from './components/utils/modalConfirmationWindowService';
import { userGroupPermissionsItem } from './components/utils/userGroupPermissionsItem';
import { userGroupPermissionsTable } from './components/utils/userGroupPermissionsTable';
import { userGroupPermissionsTree } from './components/utils/userGroupPermissionsTree';
import { ViolationsController } from './components/violations/violationsController';
import { YearPlanningController } from './components/yearPlanning/yearPlanningController';
import { configurationService } from './shared/configurationService';
import { environmentProvider, IEnvironmentProvider } from './shared/environmentService';
import { numberService } from './shared/numberService';
import { pageStartService } from './shared/pageStartService';
import { planningStatusService } from './shared/planningStatusService';
import { userService } from './shared/userService';
import { userConfigurationsService } from './shared/userConfigurationsService';
import { TransitionService } from '@uirouter/angularjs';
import { telemetryCustomProperties } from './components/utils/constants';

let baseUrl = undefined;

// !!!!!!!!!!!!!!!!!!
// NOTE: please note that we have an on-prem-app.ts too that is not part of the solution but is visible in perforce
// (same folder as this file). If you make changes here, please also change them in the on-prem-app.ts file too!
// !!!!!!!!!!!!!!!!!!

angular
  .module("omrp", [
    "ui.router",
    "ui.bootstrap",
    "ngCookies",
    "tmh.dynamicLocale",
    "ui.tree",
    noUiSliderModule,
    "auth0.auth0",
  ])
  .factory("SSOLoginData", SSOLoginData)

  .provider("environment", environmentProvider)

  .service("authenticationService", authenticationService)
  .service("authInterceptorService", authInterceptorService)
  .service("tokenExpiredInterceptorService", tokenExpiredInterceptorService)
  .service("notificationService", notificationService)
  .service("userConfigurationsService", userConfigurationsService)
  .service("userService", userService)
  .service("planningStatusService", planningStatusService)
  .service("numberService", numberService)
  .service("translationService", translationService)
  .service("modalConfirmationWindowService", modalConfirmationWindowService)
  .service("pageStartService", pageStartService)
  .service("permissionService", permissionService)
  .service("configurationService", configurationService)

  .directive("omrpCollapsible", omrpCollapsible)
  .directive("omrpColorpicker", omrpColorpicker)
  .directive("omrpDatepicker", omrpDatepicker)
  .directive("omrpDropdownFilter", omrpDropdownFilter)
  .directive("omrpDropdownTree", omrpDropdownTree)
  .directive("omrpDynamicInput", omrpDynamicInput)
  .directive("omrpSlider", omrpSlider)
  .directive("omrpTaglist", omrpTaglist)

  // Uncomment the line below to enable the performance test page on a release build(DANGEROUS).
  // .controller('PerfTestCtrl', PerfTestCtrl)
  .controller("SaveSSOTokenController", SaveSSOTokenController)
  .controller("ModalConfirmationWindowCtrl", modalConfirmationWindowCtrl)
  .controller("ActivityTypesCtrl", activityTypesCtrl)
  .controller("LangSwitchCtrl", LangSwitchCtrl)
  .controller("MonitoringPageComponentCtrl", MonitoringPageComponentCtrl)
  .controller("MonitoringPageCtrl", MonitoringPageCtrl)
  .controller("MonitoringPageCtrlBase", MonitoringPageCtrlBase)
  .controller("MonitoringPageInstanceCtrl", MonitoringPageInstanceCtrl)
  .controller("PlanboardCtrl", PlanboardCtrl)

  .controller("activityController", ActivityController)
  .controller("activityPasteController", ActivityPasteController)
  .controller("customCounterPeriodController", CustomCounterPeriodController)
  .controller(
    "exchangeUpdateConfigurationController",
    ExchangeUpdateConfigurationController
  )
  .controller("authorizeCtrl", AuthorizeController)
  .controller("loginController", LoginController)
  .controller("loginLogoutLinkController", LoginLogoutLinkController)
  .controller("mergeConflictsController", MergeConflictsController)
  .controller("multiSelectController", MultiSelectController)
  .controller("narrowCastingConfigCtrl", NarrowCastingConfigCtrl)
  .controller("planningStatusController", PlanningStatusController)

  .controller("replaceResourceController", ReplaceResourceController)
  .controller("resourceCombinationsController", ResourceCombinationsController)
  .controller("resourcesController", ResourcesController)
  .controller(
    "resourceParttimeScheduleController",
    ResourceParttimeScheduleController
  )
  .controller(
    "resourcePeriodBoundPropertiesController",
    ResourcePeriodBoundPropertiesController
  )
  .controller("scenarioManagementController", ScenarioManagementController)
  .controller("solverManagementController", SolverManagementController)
  .controller("upgradeDaymarkController", UpgradeDaymarkController)
  .controller("userPreferencesController", UserPreferencesController)
  .controller("violationsController", ViolationsController)
  .controller("yearPlanningController", YearPlanningController)

  .component("indexPage", indexPage)
  .component("modalWithCheckbox", modalWithCheckbox)
  .component("userGroupPermissionsItem", userGroupPermissionsItem)
  .component("userGroupPermissionsTable", userGroupPermissionsTable)
  .component("userGroupPermissionsTree", userGroupPermissionsTree)

  .config([
    "$qProvider",
    function ($qProvider) {
      $qProvider.errorOnUnhandledRejections(false);
    },
  ])
  .config([
    "environmentProvider",
    function (environment: IEnvironmentProvider) {
      environment.baseUrl = baseUrl;
      window["baseUrl"] = baseUrl;
    },
  ])
  .config(routeconfig)
  .config(localeconfig)
  .config(auth0config)
  .config(authinterceptorconfig)

  .config([
    "$httpProvider",
    "$provide",
    "environmentProvider",
    function (
      $httpProvider: angular.IHttpProvider,
      $provide,
      environment: IEnvironmentProvider
    ) {
      if (environment.baseUrl) {
        $provide.factory("BaseUrlInterceptor", [
          "$q",
          function ($q: angular.IQService) {
            return {
              request: function (config) {
                const url = config.url.toLowerCase();
                if (
                  url.startsWith("omrp/") ||
                  url.startsWith("dist/omrp/") ||
                  url.startsWith("api/") ||
                  url === "token" ||
                  url === "auth/logout"
                ) {
                  config.url = `${environment.baseUrl}/${config.url}`;
                }
                return config || $q.when(config);
              },
            };
          },
        ]);
        $httpProvider.interceptors.push("BaseUrlInterceptor");
      }
    },
  ])
.run([
    "$transitions",
    function ($transitions: TransitionService) {
        const connectionString = window["OMRP_ApplicationInsightsConnectionString"];
        let appInsights;
  
        if (connectionString) {
            appInsights = new ApplicationInsights({
                config: {
                    connectionString,
                },
            });
            appInsights.loadAppInsights();

            // Add global custom properties
            appInsights.addTelemetryInitializer((envelope) => {
                envelope.data = {
                    ...(envelope.data ?? {}),
                    customerName: telemetryCustomProperties.customerName,
                    customerAccountId: telemetryCustomProperties.customerAccountId,
                };
            }); 
        }

        $transitions.onSuccess({}, function (transition) {
            const toState = transition.to();

            if (appInsights && toState && toState.name) {
                 // Delay page view tracking to ensure the state transition is complete
                setTimeout(function () {
                    appInsights.trackPageView();
                }, 500);
            }
        });
    },
])
  .run(stateconfig)
  .run(clickconfig);

const ngLifecycles = (window["omrpLoadingFunction"] = singleSpaAngularJS({
  angular: window.angular,
  domElementGetter: function () {
    return document.getElementById("angularjs-container");
  },
  mainAngularModule: "omrp",
  uiRouter: true,
  template: "<index-page />",
}));

ngLifecycles.mount = [
  (props) => {
    baseUrl = props.baseUrl;

    return Promise.resolve();
  },
  ngLifecycles.mount,
];
